import * as actionTypes from "../actionTypes";
import * as api from "../../api/index";
import { toast } from 'react-toastify';

export const GoogleSignIn = (credential, navigate) => async (dispatch) => {
  try {
    const { data, status } = await api.googleAuth(credential);
    if (status === 200) {
      dispatch({
        type: actionTypes.LOG_IN,
        payload: {
          access: data.access,
          refresh: data.refresh,
          user: data.user,
        },
      });
      navigate("/app");
    }
  } catch (error) {
    toast.error("Sign in failed. Please try again.");
  }
};

export const LogOut = (navigate) => (dispatch) => {
  dispatch({ type: actionTypes.LOG_OUT });
  navigate("/auth");
};


// export const LogIn = (formData, navigate, setLoading) => async (dispatch) => {
//   dispatch({ type: actionTypes.CLEAR_ERRORS });
//   setLoading(true);
//   let res, statusCode;
//   try {
//     const { data, status } = await api.login(formData);
//     res = data;
//     statusCode = status;
//     if (status === 200) {
//       dispatch({ type: actionTypes.LOG_IN, payload: data.data });
//       // await dispatch(AssociatedCompanies(setLoading));
//       await dispatch(GetMyProfile(setLoading));
//       // toast.success(data.message);
//     }else{
//       dispatch({ type: actionTypes.SET_ERRORS, payload: data });
//     }
//     setLoading(false);
//   } catch (error) {
//     dispatch({ type: actionTypes.SET_CRASHES, payload: error });
//     setLoading(false);
//   }
//   return { res, statusCode }; 
// };

// export const Register = (formData, setLoading) => async (dispatch) => {
//   dispatch({ type: actionTypes.CLEAR_ERRORS });
//   setLoading(true);
//   let res, statusCode;
//   try {
//     const { data, status } = await api.register(formData);
//     res = data;
//     statusCode = status;
//     if (status === 201) {
//       // dispatch({ type: actionTypes.REGISTER, payload: data.data });
//       toast.success(data.message);
//     }else{
//       dispatch({ type: actionTypes.SET_ERRORS, payload: data });
//     }
//     setLoading(false);
//   } catch (error) {
//     dispatch({ type: actionTypes.SET_CRASHES, payload: error });
//     setLoading(false);
//   }
//   return { res, statusCode };
// };
